<template>
  <div id="questionView" v-if="currentQuestionID !== null">
      <Transition name="fade" mode="out-in">
        <div id="answerFeedback" v-html="answerFeedback" v-show="showFeedback"></div>
      </Transition>

      <div id="additionalBreakdownContainer">
        <div id="totalPoints">TOTAL POINTS: {{ currentQuestion.points }}</div>
        <div id="runningQuestionCount">{{`QUESTION ${ roundQuestionAnsweredCount } OF ${ roundQuestionCount }`}}</div>
      </div>

      <div id="timerContainer" :class="{'mobile-timer': !isDesktop}">
        <Transition name="fade" mode="out-in">
          <div id="questionNumber" v-show="loadedQuestionNumber">
            <div id="currentQuestion">QUESTION {{ roundQuestionAnsweredCount }}</div>
            <RadialProgress
              id="questionTimer"
              :diameter="160"
              :totalSteps="totalTicks"
              :completedSteps="remainingTicks"
              :startColor="'rgb(8, 163, 141)'"
              :stopColor="'rgb(8, 163, 141)'"
              :innerStrokeColor="'rgba(51,51,51,0.75)'"
              :animateSpeed="100"
              :strokeWidth="18"
              :innerStrokeWidth="18"
              :strokeLinecap="'square'"
            >
              <svg width="160" height="160" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <title>Timer Background</title>
                  <circle id="radialTimerCenter" r="53" cy="80" cx="80" fill="#000"></circle>
                </g>
              </svg>
              <div id="time">{{ prettyTime }}</div>
            </RadialProgress>
            <div id="currentPoints">{{ remainingPoints }} PTS</div>
          </div>
        </Transition>
      </div>

      <div id="questionContent">
        <Transition name="fade" mode="out-in">
          <div id="questionText" v-html="currentQuestion.questionText" v-show="loadedQuestionText"></div>
        </Transition>
        <Transition name="fade" mode="out-in">
          <div id="questionAnswers" v-show="loadedQuestionAnswers">
            <div class="question-answer" :class="{'selected-answer': ((!completedQuestion && selectedAnswers.includes(answerIndex)) || (completedQuestion && finalSelectedAnswers.includes(answerIndex))), 'disabled-answer': completedQuestion, 'correct-completed-answer': (completedQuestion && answer.correct)}" v-for="(answer, answerIndex) in currentQuestion.answers" :key="`answer-${answerIndex}`" @click="selectAnswer(answerIndex)">
              <div :class="{'answer-selection-icon-container': true, 'selected-correct': (completedQuestion && selectedAnswers.includes(answerIndex) && answer.correct), 'selected-incorrect': (completedQuestion && selectedAnswers.includes(answerIndex) && !answer.correct)}">
                <img class="answer-selection-icon" v-show="(!selectedAnswers.includes(answerIndex))" src="@/assets/img/MC_circle_off.png" />
                <img class="answer-selection-icon" v-show="(selectedAnswers.includes(answerIndex))" src="@/assets/img/MC_circle_selected.png" />
              </div>
              <div class="answer-text">{{ answer.answerText }}</div>
<!--               <img class="answer-icon answer-correct-icon" v-show="(completedQuestion && selectedAnswers.includes(answerIndex) && answer.correct)" src="@/assets/img/checkmark.png">
              <img class="answer-icon answer-incorrect-icon"  v-show="(completedQuestion && selectedAnswers.includes(answerIndex) && !answer.correct)" src="@/assets/img/incorrect_x.png"> -->
            </div>
          </div>
        </Transition>
      </div>
    <div id="submitButton" class="game-button" :class="{'disabled-button': (selectedAnswers.length < 1 || attemptedSubmit)}" @click="submitAnswers" v-if="(!completedQuestion && (currentQuestion.answers.filter(answer => answer.correct === true).length > 1))">
      Submit
    </div>
    <Transition name="fade" mode="out-in">
      <div id="continueContainer" @click="progressGame" v-if="showContinueButton">
        <div id="continueButton">
          <img v-show="!answeredCorrectly" src="@/assets/img/incorrect_btn.png" />
          <img v-show="answeredCorrectly" src="@/assets/img/correct_btn.png" />
        </div>
        <div id="continueBanner">
          <Transition name="fade-right" mode="out-in">
            <img v-show="showContinueBanner" src="@/assets/img/continue_btn.png" />
          </Transition>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Howl } from 'howler'
import RadialProgress from "vue3-radial-progress";

export default {
  name: 'Question',
  components: {
    RadialProgress
  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'currentUser',
      'currentView',
      'currentQuestionID',
      'currentRound',
      'questionTime',
      'questionTimeDelay',
      'questionFloatDelay',
      'randomizedQuestionOrder',
      'clientWidth',
      'breakpoints',
    ]),
    isDesktop(){
      const theQuestionView = this;
      return (theQuestionView.clientWidth > theQuestionView.breakpoints.tab);
    },
    currentQuestion(){
      const theQuestionView = this;
      // find question X for the specific user
      return theQuestionView.currentUser.questions.find(question => question.masterQuestionID === theQuestionView.currentQuestionID);
    },
    prettyTime(){
      const theQuestionView = this;
      let minutes = Math.floor(theQuestionView.remainingTime / 60);
      let seconds = (theQuestionView.remainingTime % 60);
      return `${minutes < 10 ? ('0' + minutes.toString()) : minutes}:${seconds > 9 ? seconds : ('0' + seconds.toString())}`
    },
    remainingPoints(){
      const theQuestionView = this;
      return Math.floor(theQuestionView.currentQuestion.points * (theQuestionView.remainingTicks / theQuestionView.totalTicks));
    },
    roundQuestionCount(){
      const theQuestionView = this;
      return theQuestionView.currentUser.questions.filter(question => question.roundID === theQuestionView.currentRound).length;
    },
    roundQuestionAnsweredCount(){
      const theQuestionView = this;
      const currentRoundQuestions = theQuestionView.currentUser.questions.filter(question => question.roundID === theQuestionView.currentRound);
      const currentRoundMasterQuestionIDs = currentRoundQuestions.map(question => question.masterQuestionID);
      if(theQuestionView.currentUser.completedQuestions.includes(theQuestionView.currentQuestionID)){
        return (currentRoundMasterQuestionIDs.filter(question => theQuestionView.currentUser.completedQuestions.includes(question)).length);
      }
      return (currentRoundMasterQuestionIDs.filter(question => theQuestionView.currentUser.completedQuestions.includes(question)).length + 1);
    }
  },
  methods: {
    ...mapActions([
      'onResize',
      'toggleLogoutModal',
      'updateCurrentView',
      'updateUserScore',
      'updateUserViewedQuestions',
      'updateUserCompletedQuestions',
      'updateCurrentQuestionID',
    ]),
    startCountdown(){
      const theQuestionView = this;
      theQuestionView.totalTime = theQuestionView.currentQuestion.timeOverride ? theQuestionView.currentQuestion.timeOverride : theQuestionView.questionTime;
      theQuestionView.remainingTime = theQuestionView.currentQuestion.timeOverride ? theQuestionView.currentQuestion.timeOverride : theQuestionView.questionTime;
      theQuestionView.startDelay = theQuestionView.currentQuestion.delayOverride ? theQuestionView.currentQuestion.delayOverride : theQuestionView.questionTimeDelay;
      theQuestionView.totalTicks = theQuestionView.currentQuestion.timeOverride ? (theQuestionView.currentQuestion.timeOverride * 10) : (theQuestionView.questionTime * 10);

      theQuestionView.remainingTicks = theQuestionView.currentQuestion.timeOverride ? (theQuestionView.currentQuestion.timeOverride * 10) : (theQuestionView.questionTime * 10);

      let countdownDelay = 0;
      if(theQuestionView.simultaneousLoad){
        countdownDelay = ((1000 * theQuestionView.startDelay) + 250)
      }else{
        countdownDelay = ((1000 * theQuestionView.startDelay) + (((theQuestionView.questionFloatDelay * 1000 * 2) + 250)))
      }

      theQuestionView.timerInstance = window.setTimeout(() => {
        let interval = setInterval(() => {
          if(theQuestionView.remainingTime === 0 || theQuestionView.attemptedSubmit){
            clearInterval(interval)
            // force submit if timeout
            if(!theQuestionView.attemptedSubmit){
              theQuestionView.submitAnswers(true);
            }
            clearTimeout(theQuestionView.timerInstance);
          }else{
            theQuestionView.remainingTicks--;
            if((theQuestionView.remainingTicks % 10) === 0){
              theQuestionView.remainingTime--;
            }
          }
        }, 100);
      }, countdownDelay);

    },
    selectAnswer(answerIndex){
      let theQuestionView = this;
      theQuestionView.attemptedSubmit = false;

      const hasMultipleCorrect = theQuestionView.currentQuestion.answers.filter(answer => answer.correct === true).length > 1;
      theQuestionView.showFeedback = false;
      if(theQuestionView.selectedAnswers.includes(answerIndex)){
        theQuestionView.selectedAnswers = theQuestionView.selectedAnswers.filter(selectedAnswer => selectedAnswer !== answerIndex)
      }else{
        if(hasMultipleCorrect || theQuestionView.selectedAnswers.length < 1){
          theQuestionView.selectedAnswers.push(answerIndex);
        }else if(!hasMultipleCorrect && theQuestionView.selectedAnswers.length === 1){
          theQuestionView.selectedAnswers.pop();
          theQuestionView.selectedAnswers.push(answerIndex);
        }
      }

      // auto submit if only one answer
      if(!hasMultipleCorrect){
        theQuestionView.submitAnswers();
      }
    },
    submitAnswers(timeout = false){
      const theQuestionView = this;
      theQuestionView.attemptedSubmit = true;

      let allCorrect = true;

      let correctAnswers = [];
      let awardedPoints = 0;
      let timeSpent = 0;

      theQuestionView.currentQuestion.answers.forEach((answer, answerIndex) => {
        if(answer.correct){
          correctAnswers.push(answerIndex);
          if(!theQuestionView.selectedAnswers.includes(answerIndex)){ // if missing a correct answer, entire submission is wrong
            allCorrect = false;
          }
        }else{
          if(theQuestionView.selectedAnswers.includes(answerIndex)){ // if submitted an incorrect answer, entire submission is wrong
            allCorrect = false;
          }
        }
      });

      // rough implementation to get a couple of somewhat well rounded decimal places for the time spent
      timeSpent = (Math.round(((theQuestionView.totalTicks / 10) - (theQuestionView.remainingTicks / 10)) * 100) / 100);

      if(allCorrect){
        theQuestionView.correctSound.play();
        awardedPoints = Math.floor(theQuestionView.currentQuestion.points * (theQuestionView.remainingTicks / theQuestionView.totalTicks));
        theQuestionView.updateUserScore(awardedPoints);
        theQuestionView.updateUserCompletedQuestions({masterQuestionID: theQuestionView.currentQuestion.masterQuestionID, questionRefID: theQuestionView.currentQuestion.questionRefID, answeredCorrectly: true, pointsEarned: awardedPoints, timeSpent: timeSpent});

        theQuestionView.pointsEarned = awardedPoints;
        theQuestionView.completedQuestion = true;
        theQuestionView.answeredCorrectly = true;
        theQuestionView.answerFeedback = `CORRECT!`;
        theQuestionView.showFeedback = true;
        window.setTimeout(() => {
          theQuestionView.showContinueButton = true;
        }, 750);
        window.setTimeout(() => {
          theQuestionView.showContinueBanner = true;
        }, 1000);
      }else{
        theQuestionView.incorrectSound.play();
        theQuestionView.showFeedback = true;
        // theQuestionView.selectedAnswers = correctAnswers;
        theQuestionView.finalSelectedAnswers = correctAnswers;
        if(timeout){
          theQuestionView.answerFeedback = `TIME'S UP!`;
        }else{
          theQuestionView.answerFeedback = `INCORRECT!`;
        }
        theQuestionView.updateUserCompletedQuestions({masterQuestionID: theQuestionView.currentQuestion.masterQuestionID, questionRefID: theQuestionView.currentQuestion.questionRefID, answeredCorrectly: false, pointsEarned: awardedPoints, timeSpent: timeSpent});

        theQuestionView.completedQuestion = true;
        theQuestionView.answeredCorrectly = false;
        window.setTimeout(() => {
          theQuestionView.showContinueButton = true;
          // scroll to bottom, primarily for mobile
          window.scrollTo({ top: (document.body.scrollHeight), behavior: 'smooth' });
        }, 750);
        window.setTimeout(() => {
          theQuestionView.showContinueBanner = true;
        }, 1000);
        
      }

      window.setTimeout(() => {
        theQuestionView.showFeedback = false;
      }, 300);

      clearTimeout(theQuestionView.timerInstance);
    },
    progressGame(){
      const theQuestionView = this;
      // if(theQuestionView.currentUser.completedQuestions.length === theQuestionView.roundQuestionCount){
      let completedRound = true;
      theQuestionView.currentUser.questions.filter(question => question.roundID === theQuestionView.currentRound).forEach(question => {
        if(!theQuestionView.currentUser.completedQuestions.includes(question.masterQuestionID)){
          completedRound = false;
        }
      })
      if(completedRound){
        theQuestionView.updateCurrentView('gameover')
      }else{
        theQuestionView.resetData();
        theQuestionView.loadQuestion();
      }
    },
    loadQuestion(){
      const theQuestionView = this;

      const currentRoundQuestions = theQuestionView.currentUser.questions.filter(question => question.roundID === theQuestionView.currentRound);
      const currentRoundMasterQuestionIDs = currentRoundQuestions.map(question => question.masterQuestionID);
      // const currentRoundUserQuestionIDs = currentRoundQuestions.map(question => question.userQuestionID);

      const remainingRoundQuestions = currentRoundMasterQuestionIDs.filter(question => !theQuestionView.currentUser.completedQuestions.includes(question));
      
      let sortedRemainingQuestions = [];
      let loadedQuestionID = null;

      // if randomized order
      if(theQuestionView.randomizedQuestionOrder){
        // find next question per user question ID

        let mappedRemainingUserQuestionIDs = currentRoundQuestions.filter(question => remainingRoundQuestions.includes(question.masterQuestionID)).map(question => question.userQuestionID)

        sortedRemainingQuestions = [...mappedRemainingUserQuestionIDs].sort((a,b) => {
          if(a > b){
            return 1;
          }
          if(a < b){
            return -1;
          }
          return 0;
        });

        loadedQuestionID = currentRoundQuestions.find(question => question.userQuestionID === sortedRemainingQuestions[0]).masterQuestionID;
      }else{ // otherwise just roll with master question order

        sortedRemainingQuestions = [...remainingRoundQuestions].sort((a,b) => {
          if(a > b){
            return 1;
          }
          if(a < b){
            return -1;
          }
          return 0;
        });

        loadedQuestionID = sortedRemainingQuestions[0];
      }

      theQuestionView.updateCurrentQuestionID(loadedQuestionID)

      if(!theQuestionView.currentUser.viewedQuestions.includes(theQuestionView.currentQuestion.masterQuestionID)){
        theQuestionView.updateUserViewedQuestions(theQuestionView.currentQuestion.masterQuestionID)
      }

      if(theQuestionView.simultaneousLoad){
        window.setTimeout(() => {
          theQuestionView.loadedQuestionNumber = true;
          theQuestionView.loadedQuestionText = true;
          theQuestionView.loadedQuestionAnswers = true;
        }, 250)
      }else{
        window.setTimeout(() => {theQuestionView.loadedQuestionNumber = true}, 250)
        window.setTimeout(() => {theQuestionView.loadedQuestionText = true}, ((theQuestionView.questionFloatDelay * 1000) + 250))
        window.setTimeout(() => {theQuestionView.loadedQuestionAnswers = true}, ((theQuestionView.questionFloatDelay * 1000 * 2) + 250))
      }

      theQuestionView.startCountdown();
    },
    resetData(){
      const theQuestionView = this;

      theQuestionView.completedQuestion = false;
      theQuestionView.showContinueButton = false;
      theQuestionView.showContinueBanner = false;
      theQuestionView.selectedAnswers = [];
      theQuestionView.finalSelectedAnswers = [];
      theQuestionView.attemptedSubmit = false;
      theQuestionView.showFeedback = false;
      theQuestionView.answerFeedback = '';
      theQuestionView.pointsEarned = 0;
      theQuestionView.totalTime = 0;
      theQuestionView.remainingTime = 0;
      theQuestionView.startDelay = 0;
      theQuestionView.totalTicks = 0;
      theQuestionView.remainingTicks = 0;
      theQuestionView.timerInstance = null;
      theQuestionView.loadedQuestionNumber = false;
      theQuestionView.loadedQuestionText = false;
      theQuestionView.loadedQuestionAnswers = false;
      theQuestionView.answeredCorrectly = false;

      theQuestionView.updateCurrentQuestionID(null);
    },
  },
  beforeMount(){
    const theQuestionView = this;
    theQuestionView.resetData();
    theQuestionView.loadQuestion();
  },
  mounted(){
    const theQuestionView = this;

    // load audio
    if(!theQuestionView.correctSound){
      let tempCorrectSound = new Howl({
        src: ['./assets/common/audio/correct_answer.mp3'],
        volume: 1,
        onload: () => {
          theQuestionView.correctSound = tempCorrectSound;
        },
        onloaderror: (id, error) => {
          console.log(error)
        }
      });
    }

    if(!theQuestionView.incorrectSound){
      let tempIncorrectSound = new Howl({
        src: ['./assets/common/audio/wrong_answer.mp3'],
        volume: 1,
        onload: () => {
          theQuestionView.incorrectSound = tempIncorrectSound;
        },
        onloaderror: (id, error) => {
          console.log(error)
        }
      });
    }
  },
  data(){
    return {
      simultaneousLoad: true, // Toggle if want screen components to load in individually based on float delay instead of at the same time
      completedQuestion: false,
      showContinueButton: false,
      showContinueBanner: false,
      selectedAnswers: [], // dynamically adjusted as user selects answers -- NOTE: TODO: ADJUST TEMPLATE TO INCLUDE CORRECT/INCORRECT ICON BASED ON USER ANSWERS ON SUBMIT
      finalSelectedAnswers: [], // used for final correct/incorrect answers -- NOTE: TODO: HOOK UP LOGIC IN ANSWER SUBMIT TO POPULATE AND TEMPLATE TO CHECK AGAINST
      attemptedSubmit: false,
      showFeedback: false,
      answerFeedback: '',
      pointsEarned: 0,
      correctSound: null,
      incorrectSound: null,
      totalTime: 0,
      remainingTime: 0,
      startDelay: 0,
      timerInstance: null,
      totalTicks: 0,
      remainingTicks: 0,
      loadedQuestionNumber: false,
      loadedQuestionText: false,
      loadedQuestionAnswers: false,
      answeredCorrectly: false,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #questionView{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 50px;
    width: 80%;
    margin: 0 auto;
  }
  #questionContent{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    top: -130px;
  }
  #questionNumber{
    font-size: 22px;
    font-family: 'GothamBold';
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background-color: rgba(0,0,0,.40);
    border-radius: 50px;
    height: 100px;
    width: 80%;
  }

  #timerContainer{
    position: relative;
    top: -237px;
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 647px;
    margin: 0 auto;
    justify-content: center;
  }

  #questionTimer{
    font-size: 30px;
    color: #fff;
    align-self: center;
    font-family: 'LCDBold';
  }

  #time{
    position: relative;
    top: -68px;
  }

  #currentQuestion{
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }

  #currentPoints{
    flex: 1;
    display: flex;
    justify-content: flex-start;
  }

  #questionTimer{
    flex: 1;
    display: flex;
    justify-content: center;
  }

  #additionalBreakdownContainer{
    position: relative;
    top: -50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    padding: 10px 0px;
    justify-content: center;
    background: -webkit-linear-gradient(left, rgb(2, 139, 105) 33%, rgb(255,255,255), rgb(255,255,255), rgb(255,255,255), rgb(5, 108, 84) 66%);
    font-weight: bold;
  }

  #totalPoints{
    font-size: 14px;
  }

  #runningQuestionCount{
    font-size: 20px;
  }

  #questionText{
    font-size: 23px;
    font-family: 'GothamBold';
    margin-top: 10px;
    margin-bottom: 15px;
    text-align: center;
  }
  #questionAnswers{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
/*    margin-top: 10px;*/
    width: 100%;
  }
  .question-answer{
    opacity: 1;
/*    height: 100%;*/
    width: 100%;
    max-width: 624px;
    border-radius: 15px;
    text-align: left;
    font-size: 20px;
    font-family: 'GothamBold';
    position: relative;
    display: flex;
    flex-direction: row;
/*    align-items: center;*/
    align-items: stretch;
    flex:0 0 auto;
  }

  .question-answer:not(:first-child){
/*    margin-top: 8px;*/
  }
  .question-answer:hover{
    cursor: pointer;
  }
  .disabled-answer{
    pointer-events: none;
  }
  .selected-answer{
    opacity: 1;
    pointer-events: none;
  }

  .answer-text{
    padding: 15px;
    flex: 1;
/*    min-height: 45px;*/
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .answer-selection-icon-container{
    display: flex;
    padding: 5px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    align-items: center;
  }

  .answer-selection-icon{
/*    width: 45px;*/
/*    height: 45px;*/
  }

/*  .answer-icon{
    position: absolute;
    right: 0px;
    top: 7px;
    width: 50px;
  }*/

  #answerFeedback{
    position: absolute;
    top: -75px;
    width: 100%;
    max-height: 293px;
    z-index: 1000;
    text-align: center;
    font-size: 150px;
    -webkit-animation: blurFadeInOut 3s ease-in backwards;
    -moz-animation: blurFadeInOut 3s ease-in backwards;
    -ms-animation: blurFadeInOut 3s ease-in backwards;
    animation: blurFadeInOut 3s ease-in backwards;
    -webkit-animation-delay: 0s;
    -moz-animation-delay: 0s;
    -ms-animation-delay: 0s;
    animation-delay: 0s;
  }

  #submitButton, #continueButton{
    z-index: 2;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
  }

  #continueBanner{
    position: relative;
    left: -85px;
    z-index: 1;
/*    overflow: hidden;*/
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
  }

  #continueContainer{
    position: relative;
    top: -120px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 624px;
    margin: 0 auto;
  }

  #continueButton:hover, #continueBanner:hover{
    cursor: pointer;
  }


  #correctBanner{
    z-index: 2;
  }
  #correctContainer{
    width: 80%;
    margin: 0 auto;
    max-width: 400px;
    padding: 15px;
    border-radius: 50px;
    margin-top: -85px;
    z-index: 1;
  }
  #correctContent{
    text-align: center;
    font-family: 'LuckiestGuy';
    line-height: 3rem;
    font-size: 60px;
    padding: 50px 20px 30px 20px;
    border-radius: 50px;
    -webkit-text-stroke-width: 4px;
  }
  #correctContent .points{
    font-size: 100px;
    line-height: 6rem;
  }

  @media screen and (max-width: 986px){
    #answerFeedback{
      font-size: 100px;
    }
  }

  @media screen and (max-width: 836px){
    #questionView{
      width: 100%;
    }
    #additionalBreakdownContainer{
      background: -webkit-linear-gradient(left, rgb(2, 139, 105) 25%, rgb(255,255,255), rgb(255,255,255), rgb(255,255,255), rgb(5, 108, 84) 75%);
    }
  }

  @media screen and (max-width: 642px){
    #answerFeedback{
      font-size: 80px;
    }
    #questionNumber{
      font-size: 18px;
    }
  }

  @media screen and (max-width: 521px){
    #answerFeedback{
      font-size: 65px;
    }
    #additionalBreakdownContainer{
      background: -webkit-linear-gradient(left, rgb(2, 139, 105) 20%, rgb(255,255,255), rgb(255,255,255), rgb(255,255,255), rgb(5, 108, 84) 80%);
    }
  }

  @media screen and (max-width: 496px){
    #questionNumber{
      font-size: 15px;
    }
    #correctContainer{
      margin-top: -75px;
    }
    #questionCorrect{
      max-width: 90%;
    }
    #correctContent{
      font-size: 55px;
    }
    #correctContent .points{
      font-size: 95px;
    }
    #continueButton{
      position: relative;
      left: 40px;
    }
    #continueBanner{
      left: -45px;
    }
  }
  @media screen and (max-width: 425px){
    #correctContainer{
      margin-top: -65px;
    }
    #answerFeedback{
      font-size: 50px;
    }
  }
  @media screen and (max-width: 350px){
    #correctContainer{
      margin-top: -55px;
    }
  }

  #timerContainer.mobile-timer{
    transform: scale(.65);
    top: -212px;
  }

  .zoom-in-out {
    animation: zoom-in-zoom-out 0.75s;
    animation-iteration-count: 1;
  }

  @keyframes zoom-in-zoom-out {
    0% {
      transform: scale(0, 0);
    }
    50% {
      transform: scale(1.25, 1.25);
    }
    100% {
      transform: scale(1, 1);
    }
  }

  .float-up-enter-active, .float-up-leave-active {
    transition: all 0.75s ease;
  }

  .float-up-enter-from, .float-up-leave-to {
    transform: translateY(500px);
    opacity: 0;
  }

  .fade-right-enter-active, .fade-right-leave-active{
    transition: all 0.75s ease-in-out;
  }

  .fade-right-enter-from, .fade-right-leave-to{
    transform: translateX(-155px);
    opacity: 0;
  }


  @-webkit-keyframes blurFadeInOut{
    0% {
      opacity: 0;
      text-shadow: 0px 0px 40px #fff;
      -webkit-transform: scale(1.3);
      -webkit-text-stroke: 2px #333;
    }
    20%, 75% {
      opacity: 1;
      text-shadow: 0px 0px 1px #fff;
      -webkit-text-stroke: 4px #333;
      -webkit-transform: scale(1);
    }
    100% {
      opacity: 0;
      text-shadow: 0px 0px 50px #fff;
      -webkit-transform: scale(0);
      -webkit-text-stroke: 0px #333;
    }
  }

  @-moz-keyframes blurFadeInOut {
    0% {
      opacity: 0;
      text-shadow: 0px 0px 40px #fff;
      -moz-transform: scale(1.3);
      -webkit-text-stroke: 2px #333;
    }
    20%, 75% {
      opacity: 1;
      text-shadow: 0px 0px 1px #fff;
      -webkit-text-stroke: 4px #333;
      -moz-transform: scale(1);
    }
    100% {
      opacity: 0;
      text-shadow: 0px 0px 50px #fff;
      -moz-transform: scale(0);
      -webkit-text-stroke: 0px #333;
    }
  }

  @keyframes blurFadeInOut {
    0% {
      opacity: 0;
      text-shadow: 0px 0px 40px #fff;
      transform: scale(1.3);
      -webkit-text-stroke: 2px #333;
    }
    20%, 75% {
      opacity: 1;
      text-shadow: 0px 0px 1px #fff;
      -webkit-text-stroke: 4px #333;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      text-shadow: 0px 0px 50px #fff;
      transform: scale(0);
      -webkit-text-stroke: 0px #333;
    }
  }


</style>
